import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { authHttpInterceptorFn, provideAuth0 } from '@auth0/auth0-angular';

import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { authErrorInterceptor } from './interceptors/auth-error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideAuth0({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      authorizationParams: {
        redirect_uri: window.location.origin,
        audience: environment.auth0.audience,
        // offline_access requests a refresh token so the SDK can renew the
        // access token silently when it expires. The Auth0 Application must
        // have "Allow Offline Access" enabled on the matching API for this
        // to take effect server-side.
        scope: 'openid profile email offline_access',
      },
      // localStorage is required so refresh tokens survive page reloads.
      // Tradeoff: tokens in localStorage are exposed to XSS — accepted as
      // the standard SPA-with-refresh-tokens pattern.
      cacheLocation: 'localstorage',
      useRefreshTokens: true,
      // Auth0 attaches access tokens automatically only to URLs in this
      // allowedList. Anything else (e.g. third-party domains) stays clean.
      httpInterceptor: {
        allowedList: [
          {
            uri: `${environment.apiBaseUrl}/*`,
            tokenOptions: {
              authorizationParams: {
                audience: environment.auth0.audience,
              },
            },
          },
        ],
      },
    }),
    provideHttpClient(withInterceptors([authHttpInterceptorFn, authErrorInterceptor])),
  ],
};
